import axios from "../../axios";

const checkProxy = async function (accessToken, id) {
    try {
        const response = await axios.post('proxy/checkProxy', { id }, {
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response?.status || 500,
            message: e.response?.data?.message || 'Có lỗi xảy ra'
        }
    }
}

export default checkProxy;
